import React from 'react';
import { lighten, withStyles, LinearProgress } from "@material-ui/core";
import red from '@material-ui/core/colors/red';

const COLOR_RED = red[500];

const BorderLinearProgressRed = withStyles({
  root: {
    height: 5,
    backgroundColor: lighten(COLOR_RED, 0.5),
  },
  bar: {
    borderRadius: 20,
    backgroundColor: COLOR_RED,
  },
})(LinearProgress);

export interface ProgressBarProps {
  barStyles?: string;
  value: number;
}

const ProgressBarRed = (props: ProgressBarProps) => (
  <BorderLinearProgressRed
        className={props.barStyles}
        variant="determinate"
        color="primary"
        value={props.value}
      />
);

export default ProgressBarRed;
